import _ from 'lodash';
import { mapActions } from 'vuex';
import { SCREEN_SIZE__UPDATE_SCREEN } from '@/store/types';

//eslint-disable-next-line import/prefer-default-export
export const lsScreenSizeMixin = {
  created() {
    const mediaQueries = {
      // best practice to use em breakpoints for correct behaviors in safari and matches flexboxgrid
      // 03/17/16 - https://zellwk.com/blog/media-query-units/
      mobile: '(max-width: 480px)',

      // this isn't necessarily the best breakpoint for tablets - but it was introduced as a non-breaking change
      // from our previous setup of only desktop at 1000px+ and mobile at anything under
      tablet: '(max-width: 999px) and (min-width: 481px)',

      desktop: '(min-width: 1000px)',
    };

    _.forEach(mediaQueries, (query, size) => {
      if (_.isFunction(window.matchMedia)) {
        const sizeQuery = window.matchMedia(query);
        if (sizeQuery.matches) {
          this[SCREEN_SIZE__UPDATE_SCREEN](size);
        }
        sizeQuery.addListener((mql) => {
          if (mql.matches) {
            this[SCREEN_SIZE__UPDATE_SCREEN](size);
          }
        });
      }
    });
  },
  methods: {
    ...mapActions([SCREEN_SIZE__UPDATE_SCREEN]),
  },
};
